import { AosContext } from "../Context/AosContext";
import Section from "../Section/Section";
import { FlexCnt, ImageBox, TextContainer } from "./Elements";
import { useContext } from "react";

const ZastoBasStaklo = () => {
  return (
    <Section even title="Zasto bas staklo?">
      <FlexCnt>
        <TextContainer>
          <p data-aos="fade-right">
            Staklo je idealan materijal koji se može reciklirati nebrojeno puta,
            a da to ne utiče na njegov kvalitet.
            <br />
            <br />
            Reciklaža jedne tone stakla štedi oko 40 odsto energije i 50 odsto
            vode potrebne za proizvodnju nove staklene ambalaže, dok se
            zagađenje vazduha smanjuje za oko 20 procenata.
            <br />
            <br />U Srbiji, ipak, važe druga pravila. Staklo je ovde materijal
            koji je najlakše i najisplativije baciti u kantu za smeće, a tako
            bačeno staklo završava na deponijama gde mu je potrebno 5.000 godina
            da se raspadne.
          </p>
        </TextContainer>
        <ImageBox data-aos="fade-left"></ImageBox>
      </FlexCnt>
    </Section>
  );
};

export default ZastoBasStaklo;
